import { useEffect, useRef } from 'react';
import { RouterProvider } from 'react-router-dom';

import { ToastProvider } from '../components/Toast';
import { Button, Card, ThemeProvider, ZekTecLogo, darkTheme } from '../components/ui';
import { AuthProvider, useAuth } from '../contexts/AuthContext';
import { LocaleProvider, useT } from '../i18n/messages';
import { router } from './router';

function AuthGate() {
  const auth = useAuth();
  const t = useT();
  const loginStarted = useRef(false);

  useEffect(() => {
    if (
      auth.status === 'unauthenticated' &&
      auth.error !== 'keycloak_exchange_failed' &&
      !loginStarted.current
    ) {
      loginStarted.current = true;
      void auth.login();
    }
  }, [auth]);

  if (
    auth.status === 'loading' ||
    (auth.status === 'unauthenticated' && auth.error !== 'keycloak_exchange_failed')
  ) {
    return (
      <div className="auth-shell">
        <Card className="standalone-panel standalone-panel--loading">
          <ZekTecLogo />
          <div className="standalone-panel__copy">
            <h1>{t('billing.app.title')}</h1>
            <p>{t('billing.auth.loading')}</p>
          </div>
        </Card>
      </div>
    );
  }

  if (auth.status === 'unauthenticated') {
    return (
      <div className="auth-shell">
        <Card className="standalone-panel" data-testid="billing-dashboard-login">
          <ZekTecLogo />
          <p>{t('billing.auth.loginTitle')}</p>
          <p>
            {auth.error === 'keycloak_exchange_failed'
              ? t('billing.auth.exchangeError')
              : t('billing.auth.loginBody')}
          </p>
          <div className="auth-actions">
            <Button onClick={() => void auth.login()} type="button">
              {t('billing.auth.loginAction')}
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return <RouterProvider router={router} />;
}

export function App() {
  return (
    <ThemeProvider as="div" className="app-theme" theme={darkTheme}>
      <LocaleProvider>
        <ToastProvider>
          <AuthProvider>
            <AuthGate />
          </AuthProvider>
        </ToastProvider>
      </LocaleProvider>
    </ThemeProvider>
  );
}
